<template>
    <div class="w-auto flex-col col-span-full lg:flex lg:col-span-4 lg:-ml-6 lg:col-start-9 xl:-ml-11" :class="{'md:-mt-[123px]': gallery}">
        <div v-if="gallery" class="w-full mb-6 last:mb-0 hidden shadow-3dp lg:block">
            <swiper rel="customSwiper" :options="swiperOptions" class="overflow-hidden">
                <swiper-slide v-for="(image, index) in gallery" :key="`swiper-slide-${index}-image-${image.id}`">
                    <div class="relative lg:pb-[58.4905660377%] xl:pb-[53.60576923%]">
                        <ImageBG :image="image" image-class="!h-full"/>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        
        <div class="w-full text-darkblue-800">
            <div
                class="lg:flex md:self-start flex-col bg-blue-20 lg:shadow-3dp lg:p-6"
                :class="{'hidden' : !forceDisplay}"
            >
                <h2 class="text-h6 !leading-none hidden lg:inline">Quote Builder Summary</h2>
                
                <span class="flex justify-center items-center w-fit text-darkblue border border-solid rounded-full border-darkblue text-5 !leading-none h-6 px-4 py-1 mt-4 mb-2">{{ productType }}</span>

                <div class="sticky-pricing z-10">
                    <div class="mb-2.5">
                        <div class="flex items-center justify-between text-sm w-full mb-[11px]">
                            <div class="text-3 text-3--semibold !text-darkblue-800">
                                Quantity
                            </div>
                            
                            <NumberInput :value="qty"
                                         min="1"
                                         @change="value => updateQuantity(value)"
                                         class="w-16 h-7 selected"
                                         input-class="!h-7 !min-h-[28px]"
                            />
                        </div>
                        <div class="text-4 !text-darkblue-800 w-full">
                            Delivery time is in 5-7 working days
                        </div>
                    </div>

                    <Separator/>

                    <div class="my-2.5">
                        <div class="flex justify-between text-sm w-full mb-4">
                            <div class="text-3 text-3--semibold !text-darkblue-800 !leading-none">
                                Subtotal
                            </div>
                            <div class="!text-darkblue text-3 text-3--bold !leading-none">
                                £{{ CalculatorController.getSubtotalPrice() }}
                            </div>
                        </div>
                        
                        <div class="flex justify-between text-sm w-full">
                            <div class="text-3 text-3--semibold !text-darkblue-800 !leading-none">
                                VAT (20%)
                            </div>
                            <div class="!text-darkblue text-3 text-3--bold !leading-none">
                                + £{{ CalculatorController.getTaxPrice() }}
                            </div>
                        </div>
                    </div>


                    <Separator/>

                    <div class="flex justify-between text-sm w-full my-2.5 mb-3">
                        <div class="self-start text-3 text-3--semibold !text-darkblue-800">
                            Total
                        </div>
                        <div class="flex-end font-bold text-darkblue">
                            £{{ CalculatorController.getTotalPrice() }}
                        </div>
                    </div>

                    <div class="mt-2">
                        <AddToCartButton
                            v-if="showAddToCart"
                            :add-to-cart="addToCart"
                            :enable-button="enableButton"
                            :processing-form="processingForm"
                            class="w-full btn--big h-[60px]"
                        />
                    </div>
                    <div
                        v-if="validationMessage != null && isErrorOnValidate"
                        class="text-center mt-4 p-2 text-base text-red-900 z-0"
                    >
                        <p>{{ validationMessage }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { EffectFade, Autoplay } from "swiper";
import Separator from "./helpers/Separator"
import AddToCartButton from "./helpers/AddToCartButton";
import GoToCartButton from "./helpers/GoToCartButton";
import ImageBG from "../../../../assets/js/vue/partials/ImageBG.vue";
import NumberInput from "./NumberInput.vue";
import Alert from "./Alert.vue";

export default {
    name: 'OrderSummary',
    components: {Alert, NumberInput, ImageBG, GoToCartButton, AddToCartButton, Separator, Swiper, SwiperSlide },
    props: {
        CalculatorController: {},
        addToCart: {},
        productAdded: false,
        enableButton: {},
        isErrorOnValidate: {},
        processingForm: {},
        quantity: {},
        validationMessage: {},
        updateQuantity: {
            required: true,
            default: function () {}
        },
        forceDisplay: {
            default: false
        },
        showAddToCart: {
            default: true
        },
        gallery: {},
        productType: String,
    },
    computed: {
        getTest() {
            return this.test;
        }
    },
    data(){
        return {
            qty: this.quantity,
            swiperOptions: {
                modules: [EffectFade, Autoplay],
                loop: true,
                slidersPerView: 1,
                autoplay: {
                    delay: 5000,
                },
                effect: 'fade',
                fadeEffect: {crossFade: true},
            },
            showAlert: false,
            test: 'fsdfsd',
        }
    },
}
</script>